"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTestAttributes = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _stencilReactDesc = require("@amzn/stencil-react-desc");
var _DocumentedComponent = require("../../types/DocumentedComponent");
var _utils = require("../utils");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const withTestAttributes = _ref => {
  let {
    component,
    id
  } = _ref;
  return WrappedComponent => {
    const ComponentWithTestAttributes = /*#__PURE__*/(0, _react.forwardRef)((_ref2, ref) => {
      let {
        dataTestComponent = component,
        dataTestId = id,
        ...props
      } = _ref2;
      const dataTestProps = (0, _utils.buildDataTestProps)({
        dataTestComponent,
        dataTestId
      });
      return (0, _react2.jsx)(WrappedComponent, (0, _extends2.default)({}, dataTestProps, props, {
        ref: ref
      }));
    });
    const HoistedComponent = (0, _hoistNonReactStatics.default)(ComponentWithTestAttributes, WrappedComponent);
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    ComponentWithTestAttributes.displayName = "withTestAttributes(".concat(displayName, ")");
    const description = (0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent) ? WrappedComponent.documentation.toJSON().description : '';
    const DocumentedComponentWithTestAttributes = (0, _stencilReactDesc.describe)(HoistedComponent).description(description);
    if ((0, _DocumentedComponent.isDocumentedComponent)(WrappedComponent)) {
      DocumentedComponentWithTestAttributes.propTypes = {
        ...WrappedComponent.describedPropTypes,
        dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
      };
    } else if (WrappedComponent.propTypes) {
      HoistedComponent.propTypes = {
        ...WrappedComponent.propTypes,
        dataTestId: _propTypes.default.string
      };
    }
    if (WrappedComponent.defaultProps) {
      HoistedComponent.defaultProps = {
        ...WrappedComponent.defaultProps
      };
    }
    const {
      withComponent
    } = WrappedComponent;
    if (withComponent !== undefined) {
      HoistedComponent.withComponent = tag => withTestAttributes({
        component,
        id
      })(withComponent(tag));
    }
    return DocumentedComponentWithTestAttributes;
  };
};
exports.withTestAttributes = withTestAttributes;